import { useEffect, type ReactNode } from "react";
import { Link } from "react-router-dom";

import { BrandMark } from "../../components/primitives";
import { LOGIN_PATH, PUBLIC_PATHS } from "./paths";

/** 로그인 전 화면(`P-`)의 바닥. **셀러 콘솔 셸(`Shell`·`JobShell`)을 쓰지 않는다.**
 *
 * 로그인하지 않았으니 알림도 계정도 없다. 그래서 머리 줄은 **워드마크 + `로그인`** 둘뿐이다
 * (PRD `7.0` 「로그인 전 화면」, 목업 `.pubbar`). 벨·아바타를 그리지 않는다.
 *
 * 사업자 정보 블록은 여기서 그리지 않는다. 모든 웹 화면에 같은 블록이 서야 해서
 * `App.tsx` 가 라우트 바깥에 한 번 둔다. 화면마다 그리면 한 군데가 빠진다. */
export function PublicLayout({ title, children }: { title: string; children: ReactNode }) {
  useDocumentTitle(title);
  return (
    <div className="wrap">
      <div className="shell">
        <div className="pubbar">
          <Link to={PUBLIC_PATHS.service} className="wordmark">
            <span className="mk" aria-hidden="true">
              <BrandMark size={13} />
            </span>
            makit
          </Link>
          <Link to={LOGIN_PATH} className="btn ghost small">
            로그인
          </Link>
        </div>
        <main className="panel">{children}</main>
      </div>
    </div>
  );
}

/** 브라우저 탭 제목. 목업이 `미정` 으로 둔 자리다(이 회차의 판단은 각 화면의 호출부).
 *
 * 화면을 떠나면 원래 제목(`index.html` 의 것)으로 돌려놓는다. 안 돌려놓으면 로그인 뒤 셀러
 * 콘솔 탭에 `환불정책` 이 남는다. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
